import { getQueryParams } from ".";
import { SMS_MEDIUM } from "../constants";

export const handeQueryParam = (completeUrl: string = "") => {
  if (!completeUrl) return null;
  const urlQuery = new URL(completeUrl);
  if (!urlQuery) return null;
  return getQueryParams(urlQuery?.search || "");
};

export const getParentUrlQuery = (prentUrl: string) => {
  const parentQuery = handeQueryParam(prentUrl);
  return parentQuery ?? {};
};

export const isSmsMediumThankYou = (parentUrl: string) => {
  const parentQuery = handeQueryParam(parentUrl);
  const { sms_thankyou } = parentQuery || {};
  return sms_thankyou;
};
export const changeSmsToWebUrl = (url: string) => {
  return url.replace("sms", "web");
};
export const replaceUrlInHistory = (url: string) => {
  window.history.replaceState({}, "", url);
};
export const updateChatbotUrl = (
  currentUrl: string,
  query: { [key: string]: string | null | undefined }
) => {
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url.search);

  for (const key in query) {
    if (query.hasOwnProperty(key)) {
      if (query[key] === null || query[key] === undefined) {
        // Remove the parameter if the value is null or undefined
        params.delete(key);
      } else if (typeof query[key] === "string") {
        // Update the parameter only if the value is a valid string
        params.set(key, query[key] as string);
      }
    }
  }

  return `${url.origin}${url.pathname}?${params.toString()}`;
};

export const getOriginalUrl = (
  parentUrl: string | undefined
): string | null => {
  if (!parentUrl) {
    console.error("parentUrl is undefined or empty");
    return null; // or return a default URL if needed
  }

  try {
    return new URL(parentUrl).origin;
  } catch (error) {
    console.error("Invalid parentUrl:", parentUrl);
    return null; // or return a default URL if needed
  }
};
